import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation ProvideUserEmail($chatId: ID!, $email: String!) {
    provideUserEmail(chatId: $chatId, email: $email) {
      id
      email
    }
  }
`);
